module.exports = __webpack_public_path__ + "static/img/9.a6ca5b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/9.png
// module id = I7Fr
// module chunks = 0